mutation RequestShopifyReauthUrl($shop: String!) {
  authUrl: StreamToolsRequestShopifyReauthUrl(shop: $shop) {
    url
    expiresAt
  }
}
